// extracted by mini-css-extract-plugin
export var orderDetails = "_qi-2";
export var orderImage = "_qi-1";
export var orderMeta = "_qi-3";
export var orderSummary = "_qi-0";
export var rightArrow = "_qi-4";